import Tasks from 'APP/Tasks';
import { ScheduleSettingsPopup } from 'APP/main/PopupManager/Popups/ScheduleSettingsPopup/ScheduleSettingsPopup';
import { MAX_MESSAGE_LENGTH } from 'APP/model/message/messageModel.constants';
import Entities from 'STORE';
import { Schedule } from 'STORE/Groups/Schedule';
import { TextPayload } from 'STORE/Messages/Message/Payload/TextPayload/TextPayload';
import { splitMessageText } from 'UTILS/message/message';

import { getLinkPreview } from './getLinkPreview';

export async function scheduleTextMessage(groupId: string): Promise<boolean> {
  let group = Entities.GroupsStore.getGroupById(groupId);
  group = group instanceof Schedule ? group.parentGroup : group;
  if (!group) {
    return false;
  }

  const inputPanel = Entities.InputPanelsStore.getById(groupId);
  if (!inputPanel) {
    return false;
  }

  if (inputPanel.isEmptyValue) {
    Tasks.messaging.clearInputPanel(groupId);
    return false;
  }

  const text = inputPanel.markdownValue.trim();
  const splittedTexts = splitMessageText(text, MAX_MESSAGE_LENGTH);
  const linkPreview = splittedTexts.length === 1 ? getLinkPreview(groupId) : null;
  const userMentions =
    splittedTexts.length === 1 ? Tasks.messaging.getMentionsDataFromText(text) : [];

  const payloads: TextPayload[] = splittedTexts.map((text: string): TextPayload => {
    return new TextPayload({
      text,
      linkPreview,
      linkPreviewCancelled: inputPanel.linkPreviewCancelled,
      userMentions,
    });
  });

  let sendError = '';
  payloads.some((payload: TextPayload): boolean => {
    const canSend = Tasks.messaging.canSendMessage({ groupId, payload, isCheckSlowMode: false });
    sendError = !canSend.result ? canSend.error || '' : '';
    return !!sendError;
  });

  if (sendError) {
    Tasks.app.showToast(sendError);
    return false;
  }

  Tasks.app.openPopup(ScheduleSettingsPopup, {
    params: {
      onSubmit: async (date: Date): Promise<void> => {
        const scheduleTime = date.getTime();
        const createPromises = [];

        for (let i = 0; i < payloads.length; i++) {
          createPromises.push(
            Tasks.messaging.createScheduledMessage(group.id, {
              payload: payloads[i],
              scheduleTime: scheduleTime + i,
              repliedMessage: inputPanel?.replyMessage || undefined,
              quote: inputPanel?.quote || undefined,
            })
          );
        }

        Promise.all(createPromises).then((results) => {
          if (results.some((result) => result)) {
            Tasks.group.setActiveGroup({ groupId: group.scheduleGroupId });
          }
        });
      },
    },
  });

  return true;
}
